<template>
  <div class="product__add-to-cart">
    <div class="counter">
      <button
        class="counter__btn counter__btn--less"
        :disabled="count <= 1 || !$store.getters.changesAllowed"
        :class="{ 'counter__btn--small': counterMode == 'small' }"
        @click.prevent.stop="decrease()"
      >
        <span class="screen-reader-text">{{ $modeoL10n.decrease }}</span>
      </button>
      <input
        v-model="count"
        type="number"
        class="counter__amount"
        :aria-label="$modeoL10n.amount"
        :class="{ 'counter__amount--small': counterMode == 'small' }"
        :disabled="!$store.getters.changesAllowed"
        @keydown.enter.prevent
        @keyup.enter="update(count)"
        @change="emitChange()"
      >
      <button
        :disabled="maxCount && count >= maxCount || !$store.getters.changesAllowed"
        class="counter__btn counter__btn--more"
        :class="{ 'counter__btn--small': counterMode == 'small' }"
        @click.prevent.stop="add()"
      >
        <span class="screen-reader-text">{{ $modeoL10n.increase }}</span>
      </button>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            defaultCount: {
                type: Number,
                default: 1,
            },
            counterMode: {
                type: String,
                default: '',
            },
            maxCount: {
                type: [Number, Boolean],
                default: false,
            },
        },
        data : function () {
            return {
                count : 1,
            };
        },
        created: function () {
            if (this.defaultCount) {
                this.count = parseInt(this.defaultCount);
            }
        },

        methods: {

            add() {
                this.count = parseInt(this.count) + 1;
                this.emitChange();
            },

            decrease() {
                let newCount = parseInt(this.count) - 1;
                if (newCount <= 0) {
                    newCount = 1;
                }
                this.count = newCount;
                this.emitChange();
            },

            validateInput(input) {
                input = Math.ceil(input);
                if (input <= 0) {
                    input = 1; //count must be at least 1
                }

                if (this.maxCount && input >= this.maxCount) {
                    input = this.maxCount;
                }

                return input;
            },

            emitChange() {
                this.count = this.validateInput(this.count);
                this.$emit('change', this.count);
            },

            setCount(count) {
                this.count = count;
                this.emitChange();
            },

            update(count) {
                this.count = this.validateInput(count);
                this.$emit('update', this.count);
            },

        },
    }
</script>
